import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  GET_STANDBY_TRAVELERS_RESULT_STORE_NAME,
  GetStandbyTravelersResultState,
} from './get-standby-travelers-result.state';

/** Select GetStandbyTravelersResult State */
export const selectGetStandbyTravelersResultState = createFeatureSelector<GetStandbyTravelersResultState>(
  GET_STANDBY_TRAVELERS_RESULT_STORE_NAME
);

/** Select GetStandbyTravelersResult isPending status */
export const selectGetStandbyTravelersResultIsPendingStatus = createSelector(
  selectGetStandbyTravelersResultState,
  (state) => !!state.isPending
);

/** Select GetStandbyTravelersResult isFailure status */
export const selectGetStandbyTravelersResultIsFailureStatus = createSelector(
  selectGetStandbyTravelersResultState,
  (state) => !!state.isFailure
);

/** Select GetStandbyTravelersResult state.model */
export const selectGetStandbyTravelersResponse = createSelector(
  selectGetStandbyTravelersResultState,
  (state) => state.model
);
